import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {MapPinIcon} from 'shells/icon/svg/map-pin-icon';
import {TextField} from 'shells/textfield/textfield';

import type {MeetingLocationType} from 'nutshell-graphql-types';
import type {MeetingUpdateInput} from 'nutshell-graphql-types';

import {SmallModalContent} from './small-modal-content';
import {SmallModalFooter} from './small-modal-footer';

type Props = {
    id: string;
    location: string | null | undefined;
    locationType: MeetingLocationType;
    onSave: (arg1: MeetingUpdateInput) => void;
    onFailToConnect: () => void;
    closeModal: () => void;
};

export function AddressModalContent(props: Props) {
    const [address, setAddress] = React.useState<string | null | undefined>(
        props.locationType === 'ADDRESS' ? props.location : null
    );

    return (
        <SmallModalContent
            header='Address or place'
            icon={MapPinIcon}
            subheader='Enter an address or other location where the meeting will take place.'
        >
            <TextField
                // @ts-expect-error
                name='address'
                value={address || ''}
                placeholder='Enter meeting location or address'
                onChange={(newValue) => {
                    setAddress(newValue);
                }}
            />
            <SmallModalFooter
                onFailToConnect={props.onFailToConnect}
                saveDisabled={!address}
                onSave={() => {
                    props.onSave({id: props.id, locationType: 'ADDRESS', location: address});
                }}
                closeModal={props.closeModal}
            />
        </SmallModalContent>
    );
}
